import React from "react";

export default function PhoneLandscapeBlocker() {
  return (
    <div
      className="phone-landscape-blocker fixed inset-0 z-[100] items-center justify-center bg-greyscale-2 bg-opacity-60 px-4 text-center"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="phone-landscape-title"
      aria-describedby="phone-landscape-copy"
    >
      <div className="max-w-sm space-y-4 rounded-2xl border border-primary bg-container p-6 shadow-lg">
        <div
          className="mx-auto flex h-14 w-14 items-center justify-center rounded-full border-2 border-primary text-primary"
          aria-hidden="true"
        >
          <span
            className="material-symbols-outlined text-[24px]"
            aria-hidden="true"
          >
            mobile_rotate
          </span>
          {/* <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className="h-8 w-8"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.75"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <rect x="7" y="2.5" width="10" height="19" rx="2.5" />
            <path d="M12 18.5h.01" />
            <path d="M4 8a8.5 8.5 0 0 1 2.4-2.9" />
            <path d="M20 16a8.5 8.5 0 0 1-2.4 2.9" />
          </svg> */}
        </div>

        <div className="space-y-2">
          <h1 id="phone-landscape-title" className="title-text !text-primary">
            Rotate Your Phone
          </h1>
          <p id="phone-landscape-copy" className="muted-text">
            This app is only available in portrait mode on mobile. Rotate your
            phone back upright to continue.
          </p>
        </div>
      </div>
    </div>
  );
}
